import { Box, Typography, Stack } from '@mui/material';
import { keyframes } from '@mui/system';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AssessmentIcon from '@mui/icons-material/Assessment';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const fadeLeft = keyframes`
  from { opacity:0; transform:translateX(-30px); }
  to   { opacity:1; transform:translateX(0); }
`;

const steps = [
  { num: '01', icon: <PersonAddIcon sx={{ fontSize: 28 }} />, title: 'Créez vos Profils', desc: 'Ajoutez joueurs, clubs et entraîneurs avec toutes leurs informations.' },
  { num: '02', icon: <AssessmentIcon sx={{ fontSize: 28 }} />, title: 'Évaluez & Notez', desc: 'Saisissez les stats de match, évaluations physiques et notes de scouting.' },
  { num: '03', icon: <EmojiEventsIcon sx={{ fontSize: 28 }} />, title: 'Organisez vos Tournois', desc: 'Créez des compétitions, gérez les matchs et publiez les classements.' },
  { num: '04', icon: <TrendingUpIcon sx={{ fontSize: 28 }} />, title: 'Analysez & Progressez', desc: 'Exploitez les données pour prendre les meilleures décisions.' },
];

const HowItWorks = () => (
  <Box sx={{ py: 12, px: 3, bgcolor: '#f8fafc' }}>
    <Typography variant="overline" sx={{
      letterSpacing: 4, display: 'block', textAlign: 'center', mb: 1,
      background: 'linear-gradient(135deg, #16a34a, #22c55e)',
      WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
      fontWeight: 700,
    }}>
      Comment ça marche
    </Typography>
    <Typography variant="h2" sx={{ textAlign: 'center', color: '#0f172a', fontWeight: 800, mb: 10, fontSize: { xs: '2rem', md: '3rem' } }}>
      Simple. Rapide. Efficace.
    </Typography>

    <Stack spacing={0} maxWidth={700} mx="auto" position="relative">
      {/* Vertical line */}
      <Box sx={{
        position: 'absolute', left: { xs: 28, md: 36 }, top: 60, bottom: 60, width: 2,
        background: 'linear-gradient(180deg, #22c55e, rgba(34,197,94,.1))',
      }} />

      {steps.map((s, i) => (
        <Stack key={i} direction="row" spacing={3} alignItems="flex-start" sx={{
          mb: 5, animation: `${fadeLeft} .7s ease forwards`, animationDelay: `${i * .15}s`, opacity: 0,
        }}>
          <Box sx={{
            minWidth: 56, height: 56, borderRadius: 2, position: 'relative', zIndex: 1,
            background: i === 0
              ? 'linear-gradient(135deg, #22c55e, #16a34a)'
              : 'rgba(34,197,94,.08)',
            border: i === 0 ? 'none' : '1px solid rgba(34,197,94,.25)',
            boxShadow: i === 0 ? '0 4px 14px rgba(34,197,94,.3)' : 'none',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: i === 0 ? '#fff' : '#16a34a',
            transition: 'all .3s',
          }}>
            {s.icon}
          </Box>
          <Box pt={1}>
            <Typography variant="overline" sx={{
              fontSize: '.7rem', letterSpacing: 2,
              background: 'linear-gradient(135deg, #16a34a, #22c55e)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
              fontWeight: 700,
            }}>
              {s.num}
            </Typography>
            <Typography variant="h6" sx={{ color: '#0f172a', fontWeight: 700, mb: .5 }}>{s.title}</Typography>
            <Typography variant="body2" sx={{ color: '#94a3b8', lineHeight: 1.8 }}>{s.desc}</Typography>
          </Box>
        </Stack>
      ))}
    </Stack>
  </Box>
);

export default HowItWorks;